module.exports = __webpack_public_path__ + "img/hawaii_banner.87b22954.png";